import React from "react"

export function Loading() {

    return (

        <div className="row justify-content-center mt-5">

            <button className="btn btn-primary" type="button" disabled>
                <span style={{ marginRight: "8px" }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                等待授權中...
            </button>
        </div>

    )

}
